import { getAuthToken } from '@/assets/js/Authentication'
import HttpRequest from './HttpRequest'

class DeliveryBookingProvider extends HttpRequest {
  // ─── Member ───────────────────────────────────────────────

  getVendorMemberList (query) {
    this.setHeader(getAuthToken())
    return this.get('delivery-booking/member/members', query)
  }

  inviteMember (vendorId) {
    this.setHeader(getAuthToken())
    return this.post(`delivery-booking/member/${vendorId}/invite`)
  }

  deleteMember (vendorId, memberId) {
    this.setHeader(getAuthToken())
    return this.delete(`delivery-booking/member/${vendorId}/${memberId}`)
  }

  // ─── Slots ────────────────────────────────────────────────

  getSlots () {
    this.setHeader(getAuthToken())
    return this.get('delivery-booking/config/slots')
  }

  getSlotById (id) {
    this.setHeader(getAuthToken())
    return this.get(`delivery-booking/config/slots/${id}`)
  }

  createSlot (payload) {
    this.setHeader(getAuthToken())
    return this.post('delivery-booking/config/slots', payload)
  }

  updateSlot (id, payload) {
    this.setHeader(getAuthToken())
    return this.put(`delivery-booking/config/slots/${id}`, payload)
  }

  deleteSlot (id) {
    this.setHeader(getAuthToken())
    return this.delete(`delivery-booking/config/slots/${id}`)
  }

  // ─── Holidays ─────────────────────────────────────────────

  getHolidays () {
    this.setHeader(getAuthToken())
    return this.get('delivery-booking/config/holidays')
  }

  getHolidaysByMonth (month, year) {
    this.setHeader(getAuthToken())
    return this.get('delivery-booking/config/holidays/month', { month, year })
  }

  getHolidayByDate (date) {
    this.setHeader(getAuthToken())
    return this.get(`delivery-booking/config/holidays/date/${date}`)
  }

  getHolidayById (id) {
    this.setHeader(getAuthToken())
    return this.get(`delivery-booking/config/holidays/${id}`)
  }

  createHoliday (payload) {
    this.setHeader(getAuthToken())
    return this.post('delivery-booking/config/holidays', payload)
  }

  updateHoliday (id, payload) {
    this.setHeader(getAuthToken())
    return this.put(`delivery-booking/config/holidays/${id}`, payload)
  }

  deleteHoliday (id) {
    this.setHeader(getAuthToken())
    return this.delete(`delivery-booking/config/holidays/${id}`)
  }

  // ─── Dashboard ────────────────────────────────────────────

  getWeeklyBookings (startDate) {
    this.setHeader(getAuthToken())
    return this.get('delivery-booking/warehouse/weekly', { startDate })
  }

  getWarehouseBookings (query) {
    this.setHeader(getAuthToken())
    return this.get('delivery-booking/warehouse', query)
  }

  getWarehouseBookingById (id) {
    this.setHeader(getAuthToken())
    return this.get(`delivery-booking/warehouse/detail/${id}`)
  }

  rejectBooking (id, reason) {
    this.setHeader(getAuthToken())
    return this.patch(`delivery-booking/warehouse/${id}/reject`, { reason })
  }
}

export default DeliveryBookingProvider
